import { render } from "./TooltipProvider.vue?vue&type=template&id=4108a862&ts=true"
import script from "./TooltipProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooltipProvider.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/tooltip/TooltipProvider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4108a862"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4108a862', __exports__)) {
    api.reload('4108a862', __exports__)
  }
  
  module.hot.accept("./TooltipProvider.vue?vue&type=template&id=4108a862&ts=true", () => {
    api.rerender('4108a862', render)
  })

}


export default __exports__